import {useEffect, useMemo, useState} from "react";
import {Button} from "../../../../stories/Button/Button";
import {useNavigate} from "react-router-dom";
import useAssetTableJson from "../../../../json/useAssetTableJson";
import {msgType, TableHeaderProps} from "../../../../utils/types";
import {
  GridAlignment,
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import {ColumnVisibilityFor} from "../../../../utils/Enum.Datagrid";
import Input from "../../../../stories/Input/Input";
import {StyledDatagrid} from "../../../../styles/DatagridStyles";
import Navbar from "../../../common/layout/Navbar";
import {LicenseTypes, Operation} from "../../../../utils/Enum.types";
import {Title} from "../../../../stories/Title/Title";
import Reset from "../../../../images/Reset In Red.svg";
import EyeWite from "../../../../images/EyeWhite.svg";

import View, {calDetailsType} from "./View";
import {CustomDrawer} from "../../../../styles/CustomDrawerStyles";
import {useLazyQuery, useMutation} from "@apollo/client";
import {
  GetAlcometerDetail,
  GetBlowCountDetails,
  GetItemsDetailsForAlcometers,
} from "../masters/items/queries/queries";
import {
  AddBlowCountResult,
  AddBlowCountVars,
  AddCalibrateResult,
  AddCalibrateVars,
  AtsCalibrationDetails,
  AtsCalibrationDetailsEdge,
  AtsCalibrationDetailsOrderField,
  AtsStckItemDetailsEdges,
  AtsStckItemDetailsNode,
  AtsStckItemDetailsOrderField,
  GetAlcometerDetailResult,
  GetAlcometerDetailVars,
  GetBlowCountDetailsResult,
  GetBlowCountDetailsVars,
  GetItemsDetailsResult,
  GetItemsDetailsVars,
  ItemDetailsQueryType,
  UnifiedItem,
  UpdateBlowCountResult,
  UpdateBlowCountVars,
} from "../masters/items/queries/types";
import useUrlParams from "../../../../customHooks/useUrlParams";
import {OrderDirection} from "../../../../utils/commonQueryTypes";
import {toIsoDate} from "../../../../utils/UtilFunctions";
import {
  debouncedDelay,
  EMPTY_STRING,
  emptyMessage,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
} from "../../../../utils/constants";
import InputNumber from "../../../common/Input/InputNumber";
import {Keys} from "../../../../utils/Enum.keys";
import {
  AddBlowCount,
  AddCalibrate,
  UpdateBlowCount,
} from "../masters/items/queries/mutations";
import useServerDateandTime from "../../../../customHooks/useServerDateandTime";
import useLoggedInUserDetails from "../../../../customHooks/useLoggedInUserDetails";
import MessageModal from "../../../../customComponents/MessageModal";
import useSwConfigData from "../../../../customHooks/useSwConfigData";
import {SwConfigStrValueType} from "../users/ResetUserPassword/queries/types";
import useSwConfigVars from "../../../../customHooks/useSwConfigs";
import {SwConfigQueryType} from "../masters/items/configurations/queries/type";
import { useDebounce } from "../../../../customHooks/useDebounce";
interface inEditModeType {
  flag: boolean;
  id: number;
}
const CalibrationDetails = () => {
  const navigate = useNavigate();
  const [viewDetails, setViewDetails] = useState(false);
  const {Calibration} = useAssetTableJson();

  const {customer_id} = useUrlParams();

  const [searchData, setSearchData] = useState("");
  const debouncedSearch = useDebounce(searchData, debouncedDelay);
  const [calibrationData, setCalibrationData] = useState<calDetailsType | null>(
    null
  );

  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [items, setItems] = useState<UnifiedItem[]>([]);
  const [updatedItems, setUpdatedItems] = useState<UnifiedItem[]>([]);

  const [updateFlag, setUpdateFlag] = useState(false);

  const {configData} = useSwConfigVars({
    queryType: SwConfigQueryType.BY_CONFIG_KEY,
    strValue: [SwConfigStrValueType.MAX_CALIBRATION_COUNT_FOR_ALCOMETER],
    intValue: 0,
  });

  const [message, setMessage] = useState<msgType>(emptyMessage);

  const [blow_count, setBlowCount] = useState(0);

  const [GetItem, {data, fetchMore, loading}] = useLazyQuery<
    GetItemsDetailsResult,
    GetItemsDetailsVars
  >(GetItemsDetailsForAlcometers, {
    fetchPolicy: "network-only",
  });

  const [GetAlcoDetails, {data: alcoDetails}] = useLazyQuery<
    GetAlcometerDetailResult,
    GetAlcometerDetailVars
  >(GetAlcometerDetail);

  const [
    GetUpdateCountDetails,
    {
      data: upateCountDetails,
      fetchMore: updateFetchMore,
      loading: updateLoading,
    },
  ] = useLazyQuery<GetBlowCountDetailsResult, GetBlowCountDetailsVars>(
    GetBlowCountDetails
  );

  const [CheckCount] = useLazyQuery<
    GetBlowCountDetailsResult,
    GetBlowCountDetailsVars
  >(GetBlowCountDetails);

  const [AddCount, {loading: blowLoading}] = useMutation<
    AddBlowCountResult,
    AddBlowCountVars
  >(AddBlowCount, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [UpdateCount, {loading: updateBlowLoading}] = useMutation<
    UpdateBlowCountResult,
    UpdateBlowCountVars
  >(UpdateBlowCount, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [ResetCalibrate, {loading: resetLoading}] = useMutation<
    AddCalibrateResult,
    AddCalibrateVars
  >(AddCalibrate, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const {serverDate} = useServerDateandTime();

  const {user_details} = useLoggedInUserDetails();

  const [inEditMode, setInEditMode] = useState<inEditModeType>({
    flag: false,
    id: 0,
  });

  const resetCalibrate = (itemDetailsID: number) => {
    if (customer_id) {
      ResetCalibrate({
        variables: {
          customerID: customer_id,
          todaysDate: toIsoDate(serverDate),
          user_details,
          itemDetailsID,
        },
        refetchQueries: [
          {
            query: GetBlowCountDetails,
            variables: {
              customer_id: customer_id ? customer_id : 0,
              itemDetailsID,
              itemID: alcoDetails ? alcoDetails.GetAlcometerDetail.id : 0,
              empID: user_details.id,
              after: null,
              first: ROWS_PER_PAGE,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsCalibrationDetailsOrderField.CREATED_AT,
              },
              name: EMPTY_STRING,
            },
          },
          {
            query: GetItemsDetailsForAlcometers,
            variables: {
              customerID: customer_id ? customer_id : 0,
              companyID: 0,
              subsidiaryID: 0,
              junctionID: 0,
              siteID: 0,
              input: {
                query_type: ItemDetailsQueryType.ALL,
                stckCategoryID: 0,
                stckGroupID: 0,
                stckManufacturerID: 0,
                stckUomID: 0,
                stckSubCategoryID: 0,
                itemID: 0,
                ldgrID: 0,
                empID: user_details.id,
              },
              after: null,
              first: 10,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsStckItemDetailsOrderField.CREATED_AT,
              },
              name: debouncedSearch,
            },
          },
        ],
      }).then(({data}) => {
        if (data && data.AddCalibrate) {
          setMessage({
            flag: true,
            message: "Calibration reset successfully",
            operation: Operation.CREATE,
          });
        }
      });
    }
  };
  const dynamicHeaders: TableHeaderProps[] = Calibration.List.filter(
    ({field}) => field !== "blow_date" && field !== "blow_count_to_view"
  ).map((header) => ({
    headerName: header.headerName,
    field: header.field,
    headerAlign: header.headerAlign as GridAlignment,
    align: header.align as GridAlignment,
    flex: header.flex,
    hideable: header.hideable,
    cellClassName: header.cellClassName,
    renderCell: (params) => {
      if (header.field === "actions") {
        return (
          <div className="calibration-details__tableblock--btns">
            <button
              className="calibration-details__tableblock--view"
              onClick={() => {
                if (
                  configData.data &&
                  configData.data.GetSwConfigVariables.length
                ) {
                  setCalibrationData({
                    blow_count: params.row.currentBlowCount,
                    desc: params.row.serial_no,
                    id: params.row.itemDetailsId,
                    timesCalibrated: params.row.total_times,
                    calibrationLimit:
                      configData.data.GetSwConfigVariables[0].integerValue,
                  });
                  setViewDetails(!viewDetails);
                }
              }}
            >
              View <img src={EyeWite} alt="" />
            </button>
            {configData.data &&
            params.row.currentBlowCount >=
              configData.data.GetSwConfigVariables[0].integerValue &&
            updateFlag === false ? (
              <button
                disabled={resetLoading}
                className="calibration-details__tableblock--reset"
                onClick={() => resetCalibrate(params.row.itemDetailsId)}
              >
                Reset Calibrate <img src={Reset} alt="" />
              </button>
            ) : null}
          </div>
        );
      } else if (header.field === "blow_count") {
        if (
          configData &&
          configData.data &&
          configData.data.GetSwConfigVariables.length
        )
          return (
            <>
              <b className="font-green">
                {params.row.currentBlowCount ? params.row.currentBlowCount : 0}
              </b>
              /
              <b className="font-red">
                {configData.data?.GetSwConfigVariables[0].integerValue}
              </b>
            </>
          );
        return <></>;
      } else if (header.field === "enter_blow_count") {
        return (
          <div
            style={{width: "100%", height: "100%"}}
            onClick={() => {
              if (
                updateFlag
                  ? params.row.checked
                    ? params.row.blow_count
                    : params.row.blowCount
                  : params.row.blow_count
              ) {
                setBlowCount(
                  updateFlag
                    ? params.row.checked
                      ? params.row.blow_count
                      : params.row.blowCount
                    : params.row.blow_count
                );
              }
              setInEditMode({
                flag: true,
                id: params.row.id,
              });
            }}
          >
            {inEditMode.flag && inEditMode.id === Number(params.row.id) ? (
              <>
                <InputNumber
                  name={`input_${params.id}`}
                  value={blow_count}
                  autoFocus
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setBlowCount(Number(e.target.value));
                  }}
                  onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
                    e.target.select();
                  }}
                  onBlur={() => {
                    if (
                      configData.data &&
                      blow_count <=
                        configData.data.GetSwConfigVariables[0].integerValue
                    ) {
                      if (updateFlag) {
                        const updatedData = updatedItems.map((item, index) => {
                          if (index + 1 === params.id) {
                            return {
                              ...item,
                              node: {
                                ...item.node,
                                blow_count,
                                checked: true,
                              },
                            };
                          }
                          return item;
                        });

                        setUpdatedItems(updatedData as UnifiedItem[]);
                      } else {
                        const updatedData = items.map((item, index) => {
                          if (index + 1 === params.id) {
                            return {
                              ...item,
                              node: {
                                ...item.node,
                                blow_count,
                                checked: true,
                              },
                            };
                          }
                          return item;
                        });

                        setItems(updatedData as UnifiedItem[]);
                      }
                    }
                    setInEditMode({
                      flag: false,
                      id: 0,
                    });
                    setBlowCount(0);
                  }}
                  onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                    if (e.key === Keys.ENTER) {
                      if (configData.data === undefined) {
                        setMessage({
                          flag: true,
                          message: "Max Calibration not found",
                          operation: Operation.NONE,
                        });
                        return;
                      }

                      // if (
                      //   blow_count >
                      //   configData.data.GetSwConfigVariables[0].integerValue
                      // ) {
                      //   setMessage({
                      //     flag: true,
                      //     message:
                      //       "Entered blow count is greater than max calibration",
                      //     operation: Operation.NONE,
                      //   });
                      //   return;
                      // }
                      if (updateFlag) {
                        const updatedData = updatedItems.map((item, index) => {
                          if (index + 1 === params.id) {
                            return {
                              ...item,
                              node: {
                                ...item.node,
                                blow_count: blow_count,
                                checked: true,
                              },
                            };
                          }
                          return item;
                        });

                        setUpdatedItems(updatedData as UnifiedItem[]);
                      } else {
                        const updatedData = items.map((item, index) => {
                          if (index + 1 === params.id) {
                            return {
                              ...item,
                              node: {
                                ...item.node,
                                blow_count: blow_count,
                                checked: true,
                              },
                            };
                          }
                          return item;
                        });

                        setItems(updatedData as UnifiedItem[]);
                      }

                      if (Number(params.id) + 1 <= rows.length) {
                        setInEditMode({
                          flag: true,
                          id: Number(params.id) + 1,
                        });
                      }

                      if (rows.length > params.row.id) {
                        setBlowCount(
                          updateFlag
                            ? rows[params.row.id].checked
                              ? rows[params.row.id].blow_count
                              : rows[params.row.id].blowCount
                            : rows[params.row.id].blow_count
                        );
                      }
                    }
                  }}
                />
              </>
            ) : (
              <b>
                {updateFlag
                  ? params.row.checked
                    ? params.row.blow_count
                    : params.row.blowCount
                  : params.row.blow_count}
              </b>
            )}
          </div>
        );
      }

      return params.value;
    },
  }));
  const columns: GridColDef[] = [...dynamicHeaders];

  const rows: GridValidRowModel[] = useMemo(() => {
    if (updateFlag)
      return updatedItems.map(({node: data}, index) => {
        const dataModified = data as AtsCalibrationDetails;
        return {
          id: index + 1,
          serial_no: dataModified.itemDetails.prodSerialNo
            ? dataModified.itemDetails.prodSerialNo
            : "",
          blow_count: dataModified.blow_count,
          blowCount: dataModified.blowCount,
          total_times: dataModified.itemDetails.calibrationCount,
          currentBlowCount: dataModified.itemDetails.currentBlowCount,
          itemDetailsId: dataModified.id,
          checked: dataModified.checked,
        };
      });
    else
      return items.map(({node: data}, index) => {
        const dataModified = data as AtsStckItemDetailsNode;
        return {
          id: index + 1,
          serial_no: dataModified.prodSerialNo,
          blow_count: dataModified.blow_count,
          total_times: dataModified.calibrationCount,
          currentBlowCount: dataModified.currentBlowCount,
          itemDetailsId: dataModified.id,
          checked: false,
        };
      });
  }, [items, updateFlag, updatedItems]);

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.CALIBRATION_DETAILS
    );
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  useEffect(() => {
    if (customer_id) {
      GetAlcoDetails({
        variables: {
          customerID: customer_id ? customer_id : 0,
        },
      });
    }
  }, [GetAlcoDetails, customer_id]);

  useEffect(() => {
    if (customer_id && !updateFlag && alcoDetails) {
      GetItem({
        variables: {
          customerID: customer_id ? customer_id : 0,
          companyID: 0,
          subsidiaryID: 0,
          junctionID: 0,
          siteID: 0,
          input: {
            query_type: ItemDetailsQueryType.ALL,
            stckCategoryID: 0,
            stckGroupID: 0,
            stckManufacturerID: 0,
            stckUomID: 0,
            stckSubCategoryID: 0,
            itemID: alcoDetails.GetAlcometerDetail.id,
            ldgrID: 0,
            empID: user_details.id,
          },
          after: null,
          first: 10,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsStckItemDetailsOrderField.CREATED_AT,
          },
          name: debouncedSearch,
        },
      });
    }
  }, [
    GetItem,
    customer_id,
    debouncedSearch,
    updateFlag,
    user_details.id,
    alcoDetails,
  ]);

  useEffect(() => {
    if (customer_id && updateFlag && alcoDetails) {
      GetUpdateCountDetails({
        variables: {
          customer_id: customer_id ? customer_id : 0,
          itemDetailsID: 0,
          empID: user_details.id,
          after: null,
          itemID: alcoDetails.GetAlcometerDetail.id,
          todaysDate: toIsoDate(serverDate),
          first: ROWS_PER_PAGE,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsCalibrationDetailsOrderField.CREATED_AT,
          },
          name: debouncedSearch,
        },
      });
    }
  }, [
    GetUpdateCountDetails,
    alcoDetails,
    customer_id,
    debouncedSearch,
    serverDate,
    updateFlag,
  ]);

  useEffect(() => {
    if (data && !loading && !updateFlag) {
      const newData = data.GetItemsDetails.edges.map(({node}) => ({
        node: {
          ...node,
          blow_count: 0,
        },
      }));

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = items.find(
            (employee) => employee.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
                blow_count: 0,
              },
            };
          }
          return newCompany;
        });
        setItems(updatedNewData);
      } else {
        setItems(newData);
      }
      setEndCursor(data.GetItemsDetails.pageInfo.endCursor);
    }
    // eslint-disable-next-line
  }, [data, loading, updateFlag]);

  useEffect(() => {
    if (upateCountDetails && !updateLoading && updateFlag) {
      const newData = upateCountDetails.GetBlowCountDetails.edges.map(
        ({node}, index) => ({
          node: {
            ...node,
            blow_count: 0,
            checked: false,
          },
        })
      );

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = items.find(
            (employee) => employee.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
                blow_count: 0,
                checked: false,
              },
            };
          }
          return newCompany;
        });
        setUpdatedItems(updatedNewData);
      } else {
        setUpdatedItems(newData);
      }
      setEndCursor(upateCountDetails.GetBlowCountDetails.pageInfo.endCursor);
    }
    // eslint-disable-next-line
  }, [upateCountDetails, updateLoading, updateFlag]);

  const handleScroll = () => {
    if (hasNextPage && !loading) {
      fetchMore({
        variables: {
          first: FETCH_MORE_DATA,
          after: endCursor,
        },
        updateQuery: (prevResult, {fetchMoreResult}) => {
          if (!fetchMoreResult) return prevResult;

          const newEdges = fetchMoreResult.GetItemsDetails.edges.map(
            ({node}) => ({
              node: {
                ...node,
                blow_count: 0,
              },
            })
          );
          const pageInfo = fetchMoreResult.GetItemsDetails.pageInfo;
          setEndCursor(pageInfo.endCursor);
          setHasNextPage(pageInfo.hasNextPage);

          const duplicateCheck = prevResult.GetItemsDetails.edges.filter(
            ({node: {id}}) =>
              newEdges.findIndex(({node: {id: newId}}) => newId === id) !== -1
          );

          if (duplicateCheck.length > 0) return prevResult;

          return {
            GetItemsDetails: {
              edges: [...(items as AtsStckItemDetailsEdges[]), ...newEdges],
              pageInfo,
              totalCount: data ? data.GetItemsDetails.totalCount! : 0,
            },
          };
        },
      });
    }
  };

  const handleUpdateScroll = () => {
    if (hasNextPage && !updateLoading) {
      updateFetchMore({
        variables: {
          first: FETCH_MORE_DATA,
          after: endCursor,
        },
        updateQuery: (prevResult, {fetchMoreResult}) => {
          if (!fetchMoreResult) return prevResult;

          const newEdges = fetchMoreResult.GetBlowCountDetails.edges.map(
            ({node}) => ({
              node: {
                ...node,
                blow_count: 0,
                checked: false,
              },
            })
          );
          const pageInfo = fetchMoreResult.GetBlowCountDetails.pageInfo;
          setEndCursor(pageInfo.endCursor);
          setHasNextPage(pageInfo.hasNextPage);

          const duplicateCheck = prevResult.GetBlowCountDetails.edges.filter(
            ({node: {id}}) =>
              newEdges.findIndex(({node: {id: newId}}) => newId === id) !== -1
          );

          if (duplicateCheck.length > 0) return prevResult;

          return {
            GetBlowCountDetails: {
              edges: [
                ...(updatedItems as AtsCalibrationDetailsEdge[]),
                ...newEdges,
              ],
              pageInfo,
              totalCount: upateCountDetails
                ? upateCountDetails.GetBlowCountDetails.totalCount!
                : 0,
            },
          };
        },
      });
    }
  };

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.CALIBRATION_DETAILS,
      JSON.stringify(newModel)
    );
  };

  const handleSave = () => {
    if (customer_id) {
      if (updateFlag) {
        UpdateCount({
          variables: {
            customerID: customer_id,
            input: (updatedItems as AtsCalibrationDetailsEdge[])
              .filter((item) => item.node.blow_count && item.node.checked)
              .map((item, index) => {
                return {
                  blowCount: item.node.blow_count,
                  calibrationID: item.node.id,
                };
              }),
            user_details,
          },
          refetchQueries: [
            {
              query: GetBlowCountDetails,
              variables: {
                customer_id: customer_id ? customer_id : 0,
                itemDetailsID: calibrationData ? calibrationData.id : 0,
                itemID: alcoDetails ? alcoDetails.GetAlcometerDetail.id : 0,
                empID: user_details.id,
                after: null,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsCalibrationDetailsOrderField.CREATED_AT,
                },
                name: EMPTY_STRING,
              },
            },
            {
              query: GetItemsDetailsForAlcometers,
              variables: {
                customerID: customer_id ? customer_id : 0,
                companyID: 0,
                subsidiaryID: 0,
                junctionID: 0,
                siteID: 0,
                input: {
                  query_type: ItemDetailsQueryType.ALL,
                  stckCategoryID: 0,
                  stckGroupID: 0,
                  stckManufacturerID: 0,
                  stckUomID: 0,
                  stckSubCategoryID: 0,
                  itemID: 0,
                  ldgrID: 0,
                  empID: user_details.id,
                },
                after: null,
                first: 10,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsStckItemDetailsOrderField.CREATED_AT,
                },
                name: debouncedSearch,
              },
            },
          ],
        }).then(({data}) => {
          if (data && data.UpdateBlowCount) {
            setMessage({
              flag: true,
              message: "Blow count updated successfully",
              operation: Operation.CREATE,
            });
          }
        });
      } else
        AddCount({
          variables: {
            customerID: customer_id,
            todaysDate: toIsoDate(serverDate),
            user_details,
            input: (items as AtsStckItemDetailsEdges[])
              .filter((item) => item.node.blow_count)
              .map((item, index) => {
                return {
                  blowCount: item.node.blow_count,
                  itemDetailsID: item.node.id,
                };
              }),
          },
          refetchQueries: [
            {
              query: GetBlowCountDetails,
              variables: {
                customer_id: customer_id ? customer_id : 0,
                itemID: alcoDetails ? alcoDetails.GetAlcometerDetail.id : 0,
                empID: user_details.id,
                itemDetailsID: calibrationData ? calibrationData.id : 0,
                after: null,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsCalibrationDetailsOrderField.CREATED_AT,
                },
                name: EMPTY_STRING,
              },
            },
            {
              query: GetItemsDetailsForAlcometers,
              variables: {
                customerID: customer_id ? customer_id : 0,
                companyID: 0,
                subsidiaryID: 0,
                junctionID: 0,
                siteID: 0,
                input: {
                  query_type: ItemDetailsQueryType.ALL,
                  stckCategoryID: 0,
                  stckGroupID: 0,
                  stckManufacturerID: 0,
                  stckUomID: 0,
                  stckSubCategoryID: 0,
                  itemID: 0,
                  ldgrID: 0,
                  empID: user_details.id,
                },
                after: null,
                first: 10,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsStckItemDetailsOrderField.CREATED_AT,
                },
                name: debouncedSearch,
              },
            },
          ],
        }).then(({data}) => {
          if (data && data.AddBlowCount) {
            setMessage({
              flag: true,
              message: "Blow count added successfully",
              operation: Operation.CREATE,
            });
          }
        });
    }
  };
  useEffect(() => {
    setSearchData("");
    setItems([]);
  }, [updateFlag]);

  const handleClear = () => {
    const updatedData = items.map((item) => ({
      ...item,
      node: {...item.node, blow_count: 0},
    }));
    setItems(updatedData as UnifiedItem[]);
    setSearchData("");
  };

  const handleUpdateButton = () => {
    if (customer_id) {
      CheckCount({
        variables: {
          customer_id: customer_id ? customer_id : 0,
          itemDetailsID: 0,
          itemID: alcoDetails ? alcoDetails.GetAlcometerDetail.id : 0,
          after: null,
          empID: user_details.id,

          todaysDate: toIsoDate(serverDate),
          first: ROWS_PER_PAGE,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsCalibrationDetailsOrderField.CREATED_AT,
          },
          name: debouncedSearch,
        },
      }).then(({data}) => {
        if (data && data.GetBlowCountDetails.totalCount) {
          setUpdateFlag(!updateFlag);
        } else {
          setMessage({
            flag: true,
            message: "No data found for update",
            operation: Operation.NONE,
          });
        }
      });
    }
  };

  return (
    <>
      <Navbar NavType={LicenseTypes.DASHBOARD} />
      <Title>{updateFlag ? "Update" : ""} Calibration details</Title>
      <div className="calibration-details">
        <div className="calibration-details__flex row g-0">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search..."
              value={searchData}
              onChange={(e) => {
                setSearchData(e.target.value);
              }}
            />
          </div>
          {alcoDetails && alcoDetails.GetAlcometerDetail ? (
            <div className="col">
              <Title variant="subtitle1">
                <b>{alcoDetails.GetAlcometerDetail.desc}</b>
                {alcoDetails.GetAlcometerDetail.code ? (
                  <>({alcoDetails.GetAlcometerDetail.code})</>
                ) : null}
              </Title>
            </div>
          ) : null}
          <div className="col-2 flex-end">
            <div className="overall-total-count">
              Total :{" "}
              <b>
                {updateFlag
                  ? upateCountDetails
                    ? upateCountDetails.GetBlowCountDetails.totalCount
                    : 0
                  : data
                  ? data.GetItemsDetails.totalCount
                  : 0}
              </b>
            </div>
          </div>
        </div>
        <div className="calibration-details__tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={100}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={handleColumnVisibilityChange}
            initialState={{
              columns: {
                columnVisibilityModel: columnVisibilityModel,
              },
            }}
            onRowsScrollEnd={() => {
              if (updateFlag) {
                handleUpdateScroll();
              } else handleScroll();
            }}
            disableRowSelectionOnClick
            hideFooter
          />
        </div>
        <Button
          mode="save"
          onClick={handleSave}
          loading={blowLoading || updateBlowLoading}
        />
        {!updateFlag && (
          <Button
            mode="update"
            onClick={handleUpdateButton}
            loading={blowLoading || updateBlowLoading}
          />
        )}
        {updateFlag ? (
          <Button
            mode="cancel"
            loading={blowLoading || updateBlowLoading}
            onClick={() => {
              setUpdateFlag(!updateFlag);
            }}
          />
        ) : (
          <>
            <Button
              mode="clear"
              loading={blowLoading || updateBlowLoading}
              onClick={handleClear}
            />
            <Button
              mode="back"
              loading={blowLoading || updateBlowLoading}
              onClick={() => navigate(-1)}
            />
          </>
        )}
      </div>
      <CustomDrawer
        anchor="right"
        open={viewDetails}
        onClose={() => setViewDetails(!viewDetails)}
      >
        <View setModalFlag={setViewDetails} calDetails={calibrationData} />
      </CustomDrawer>
      <MessageModal
        handleClose={() => {
          setMessage(emptyMessage);
        }}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </>
  );
};

export default CalibrationDetails;
